import { FC } from 'react';
import { Badge } from '@salecycle/ui-component-library';
import { campaignActivityStatesConfig } from '../utils/campaignActivityStatesConfig';
import { LifeCycle } from '../entities/offsiteCampaign';
import { getActivityState } from '../utils/activity-state';
import { useTranslation } from 'react-i18next';

interface IProps {
  lifeCycle: LifeCycle;
}

export const StateBadge: FC<IProps> = ({ lifeCycle }) => {
  const { t } = useTranslation('campaigns');
  if (!lifeCycle) {
    return null;
  }
  const badgeProps = campaignActivityStatesConfig(t)[getActivityState(lifeCycle)];
  return <Badge color={badgeProps?.color}>{badgeProps?.text}</Badge>;
};

export default StateBadge;
